import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ChatQuote from "@/components/ChatQuote";
import MobileStickyCTA from "@/components/MobileStickyCTA";

const Layout = ({ children }) => (
  <div className="flex min-h-screen flex-col bg-background text-foreground">
    <Header />
    <main className="flex-1 pb-16 md:pb-0">{children}</main>
    <Footer />
    <ChatQuote />
    <MobileStickyCTA />
  </div>
);

export default Layout;
